import axios from 'axios';
import { localDevelopment } from './StaticVariables';
window.onemapSuggestToken = false;

const liveCredentialsUrl = `https://grasp_internal_test.cdc.gov/eji/OneMapGeocodeToken/Search`;
const localCredentialsUrl = `https://grasp_internal_test.cdc.gov/EJISearchApi/Search`;
const credentialsUrl = localDevelopment ? localCredentialsUrl : liveCredentialsUrl;
const geoCodeServerUrl = `https://onemap.cdc.gov/OneMapServices/rest/services/Geocode/NorthAmerica/GeocodeServer`;

const getCredentials = async () => {
    var token = window.onemapSuggestToken;
    if (token !== false) return token;
    return getCredentialsFromAPI().then((obj) => {
        window.onemapSuggestToken = obj.access_token;
        return window.onemapSuggestToken;
    });
};

const getCredentialsFromAPI = async () => {
    return axios
        .get(credentialsUrl)
        .then((res) => {
            if (res.data.error?.error) {
                throw new Error(res.data.error.error);
            } else {
                const { access_token, expires_in: expires_in_seconds } = res.data; //expiration is in seconds
                return { access_token, expires: expires_in_seconds * 1000 + new Date().getTime() };
            }
        })
        .catch((err) => {
            return { access_token: false, expires: 0 };
        });
};

export const onemapSuggest = async (text, extent) => {
    const creds = await getCredentials();
    return axios.get(`${geoCodeServerUrl}/suggest?f=json&countryCode=USA&category=Address,Primary Postal,City,Subregion,Region&maxSuggestions=10&text=${text}&searchExtent=${extent}&token=${creds}`).then((data) => {
        //https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates
        return data;
    });
};

export const onemapFindAddress = async (magicKey, extent) => {
    const creds = await getCredentials();
    return axios.get(`${geoCodeServerUrl}/findAddressCandidates?f=json&countryCode=USA&magicKey=${magicKey}&searchExtent=${extent}&token=${creds}`).then((data) => {
        return data;
    });
};
